import React from 'react';
import { useDispatch } from 'react-redux';
import {
  CardSession,
  ImageWrapper,
  InitSession,
  Session,
  Nav,
  Item,
  ItemWrapper,
  List,
  Content,
  Text,
  Allies,
  ButtonAccount,
  User,
  UserWrapper,
  CloseSession,
  LoaderWrapper,
  LogoComercio
} from './styled';
import * as ImgLogoComercio from '@app/src/assets/img/logo-gec-grey.svg';
import * as ImgLogoTrome from '@app/src/assets/img/logo-trome-grey.svg';
import * as ImgLogoDepor from '@app/src/assets/img/logo-depor-grey.svg';
import * as ImgLogoPeru21 from '@app/src/assets/img/logo-peru-21-grey.svg';
import * as ImgProfileDefault from '@app/src/assets/img/profile-default.png';
import { COLORS } from '@app/src/ui';
import { navigationMainList } from '@app/src/config/header';
import { Icon } from '@app/src/common/Icon';
import { setUserPasarella } from '@app/src/common/session';
import { isClientEnv } from '@app/src/utils/validations';

interface Props {
  userName?: string;
  handleClickInitSession: Function;
  handleClickCloseSession: Function;
  handleClickAccount: Function;
  handleClickItem?: Function;
  isLoadingLogout?: boolean;
}

const isClient = isClientEnv();

export const MainList: React.FC<Props> = ({
  userName,
  handleClickInitSession,
  handleClickCloseSession,
  handleClickAccount,
  handleClickItem,
  isLoadingLogout
}) => {
  const dispatch = useDispatch();

  const handleClick = (e, item) => {
    if (isClient) {
      e.preventDefault();
      handleClickItem && handleClickItem();
      dispatch(setUserPasarella(item.pasarella));
      sessionStorage.removeItem('print');
      window.location.href = item.url;
    }
  };

  return (
    <Content>
      <CardSession>
        <ImageWrapper>
          <img src={ImgProfileDefault} alt="imagen perfil usuario" />
        </ImageWrapper>
        <Session>
          {
            userName ?
              <React.Fragment>
                <p>Hola, <User>{userName}</User></p>
                <UserWrapper>
                  <ButtonAccount
                    handleClick={handleClickAccount}
                    width={96}
                    color={COLORS.BLACK_BOLD}
                    background="#fff">
                    Mi cuenta
                  </ButtonAccount>
                  <CloseSession
                    href="#"
                    onClick={handleClickCloseSession}>
                    Cerrar sesión {
                      isLoadingLogout &&
                      <LoaderWrapper>
                        <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
                      </LoaderWrapper>}
                  </CloseSession>
                </UserWrapper>
              </React.Fragment>
              :
              <React.Fragment>
                <p>Ingresa a tu cuenta</p>
                <InitSession href="#" onClick={handleClickInitSession}>Iniciar sesión en tu cuenta</InitSession>
              </React.Fragment>
          }
        </Session>
      </CardSession>
      <Nav>
        <List>
          {
            navigationMainList.map((item, index) =>
              <ItemWrapper key={index}>
                <Item href={item.url} onClick={e => handleClick(e, item)}><Text new={item.new}>{item.text}</Text></Item>
              </ItemWrapper>)
          }
        </List>
      </Nav>
      <Allies>
        <LogoComercio src={ImgLogoComercio} />
        <img src={ImgLogoTrome} />
        <img src={ImgLogoDepor} />
        <img src={ImgLogoPeru21} />
      </Allies>
    </Content>
  )
};